import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Navigation from '../components/shared/Navigation';
import Footer from '../components/shared/Footer';
import UnitCard from '../components/shared/UnitCard';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function UnitsPage() {
  const [units, setUnits] = useState([]);
  const [activeTab, setActiveTab] = useState('rental');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`${API_URL}/api/units?type=${activeTab}`)
      .then(res => res.json())
      .then(data => {
        setUnits(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, [activeTab]);

  return (
    <div>
      <Navigation />
      
      <div className="container section-spacing">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-[var(--font-display)] tracking-[-0.02em] mb-6">
            Find Your Perfect Home
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
            Explore our available units for rent and for sale
          </p>
        </motion.div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-2 mb-8">
            <TabsTrigger data-testid="units-tabs-rentals" value="rental">Rentals</TabsTrigger>
            <TabsTrigger data-testid="units-tabs-for-sale" value="for_sale">For Sale</TabsTrigger>
          </TabsList>

          <TabsContent value="rental" className="mt-8">
            {loading ? (
              <div className="text-center py-12">Loading units...</div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
                {units.map((unit, idx) => (
                  <UnitCard key={unit.id} unit={unit} delay={idx * 0.1} />
                ))}
              </div>
            )}
          </TabsContent>

          <TabsContent value="for_sale" className="mt-8">
            {loading ? (
              <div className="text-center py-12">Loading units...</div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {units.map((unit, idx) => (
                  <UnitCard key={unit.id} unit={unit} delay={idx * 0.1} />
                ))}
              </div>
            )}
          </TabsContent>
        </Tabs>
      </div>

      <Footer />
    </div>
  );
}